import React from "react";
import { Aside } from "sprint-common-web";

import { EditMovieVersionForm, UpdatedVersionData } from "./EditMovieVersionForm";

export interface EditMovieVersionAsideProps {
    isOpen: boolean;
    defaultItemId: string;
    onClose(): void;
    onSubmit(updatedVersionData: UpdatedVersionData): void;
}

export const EditMovieVersionAside: React.FunctionComponent<EditMovieVersionAsideProps> = (
    props: EditMovieVersionAsideProps
) => {
    const closeSidebrar = () => {
        props.onClose();
    };

    const handleSubmit = (updatedVersionData: UpdatedVersionData) => {
        props.onSubmit(updatedVersionData);
    };

    return (
        <Aside isOpen={props.isOpen} type="form" headerText="Edit Movie Version" onDismiss={closeSidebrar}>
            <EditMovieVersionForm
                onCancel={closeSidebrar}
                onSubmit={handleSubmit}
                movieVersionId={props.defaultItemId}
            />
        </Aside>
    );
};
